export default __webpack_public_path__ + "static/media/2.4594e0a3.png";